import { InputReportEventData } from '@sironamedical/common/constants/crossTabEvents';
import { GamepadActionId } from 'generated/graphql';
import { NameSpaces, useCrossTabEventsListener } from 'modules/EventsManager';
import { useRef } from 'react';
import {
  SPEECHMIKE_III_WEBHID_ACTION_MAP,
  SpeechMikeIIIWebHIDValueMap,
} from 'utils/dictaphone/products';

export type WebHIDBindingsCallback = (params: {
  action: GamepadActionId;
  pressed: boolean;
  value: number;
}) => void;

export const useWebHIDBindings = ({ callback }: { callback: WebHIDBindingsCallback }): void => {
  const lastValue = useRef<InputReportEventData>({ value: 0, pressed: false });

  useCrossTabEventsListener(NameSpaces.INPUTREPORT_EVENT, ({ payload }) => {
    const { value, pressed } = payload;
    if (lastValue.current.value === value && lastValue.current.pressed === pressed) {
      return;
    }
    lastValue.current = payload;
    const action = SPEECHMIKE_III_WEBHID_ACTION_MAP[
      value as SpeechMikeIIIWebHIDValueMap
    ] as GamepadActionId;
    if (action == null) {
      return;
    }
    callback({ action, pressed, value });
  });
};
